module.exports = "/_next/static/images/4e71331a5e54833f510a04fc5d360f5c-card-and-phone-3d-xs@3x.jpg";